module.exports = __webpack_public_path__ + "img/0Q3A5767_FoamcoreMatted.b38b13c6.jpg";